import * as Y from 'yjs';
export const createLiveYDoc = () => {
    return new Y.Doc();
};
//# sourceMappingURL=create-live-ydoc.js.map